import { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { BOOKING_URL } from '../data/booking';
import './room-booking-options.css';

function RoomBookingOptions({ roomName, onWebsite, buttonLabel = 'Book this room' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="button button--gold" onClick={() => setOpen(true)}>{buttonLabel} <SafeIcon name="ArrowUpRight" /></button>
      {open && <div className="room-options__backdrop" onMouseDown={(event) => event.target === event.currentTarget && setOpen(false)}>
        <section className="room-options" role="dialog" aria-modal="true" aria-label={`Book ${roomName}`}>
          <button className="room-options__close" type="button" onClick={() => setOpen(false)} aria-label="Close booking options"><SafeIcon name="X" /></button>
          <span>YOUR STAY AT LEOPARD BLISS</span>
          <h2>Book {roomName}</h2>
          <p>Choose how you would like to plan your stay.</p>
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="room-options__choice">Book through Booking.com <SafeIcon name="ArrowUpRight" /></a>
          <button type="button" className="room-options__choice room-options__choice--light" onClick={() => { setOpen(false); onWebsite(); }}>Book via our website <SafeIcon name="ArrowRight" /></button>
          <small>Website bookings start with an enquiry; our team will confirm availability.</small>
        </section>
      </div>}
    </>
  );
}

export default RoomBookingOptions;